// TODO: we should use the features list from the backend
const PRICEMODEL_FEATURE_IDS = {
  ACADEMY: {id: 'ACADEMY'},
  AUTO_DIVIDEND_SERVICE: {id: 'AUTO_DIVIDEND_SERVICE'},
  BACKTESTING: {id: 'BACKTESTING'},
  ETF_SCREENER: {id: 'ETF_SCREENER'},
  MONITORING: {id: 'MONITORING'},
  NEWS: {id: 'NEWS'},
  PORTFOLIO: {id: 'PORTFOLIO', singular: 'Portfolio', plural: 'Portfolios'},
  PORTFOLIO_UPLOAD_DOWNLOAD: {id: 'PORTFOLIO_UPLOAD_DOWNLOAD'},
  KEY_FIGURES: {id: 'KEY_FIGURES'},
  SHARE_RATING: {id: 'SHARE_RATING'},
  SHARE_SCREENER: {id: 'SHARE_SCREENER'},
  STRATEGIES: {id: 'STRATEGIES'},
  WATCHLIST: {id: 'WATCHLIST', singular: 'Watchlist', plural: 'Watchlists'},
}

const PRICEMODEL_FEATURE_RESTRICTIONS = {
  QUANTITY: 'QUANTITY',
  QUALITY: 'QUALITY',
  UNAVAILABLE: 'UNAVAILABLE',
  INACTIVE: 'INACTIVE',
}

export {PRICEMODEL_FEATURE_IDS, PRICEMODEL_FEATURE_RESTRICTIONS}
